// Plays muted product videos (snippets/ambient-video.liquid) only while they are on
// screen, so a grid full of video cards does not download or decode them all at once.
(() => {
  if (window.ambientVideoObserver || !('IntersectionObserver' in window)) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const selector = 'video[data-ambient-video]';

  const play = (video) => {
    video.muted = true;
    const promise = video.play();
    if (promise) promise.catch(() => {});
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !reducedMotion.matches) play(entry.target);
        else entry.target.pause();
      });
    },
    { rootMargin: '200px 0px', threshold: 0.01 }
  );
  window.ambientVideoObserver = observer;

  const bind = (root) => {
    if (root.matches && root.matches(selector)) observer.observe(root);
    if (root.querySelectorAll) root.querySelectorAll(selector).forEach((video) => observer.observe(video));
  };

  bind(document);

  // Filters, endless scroll, recommendations and the media modal add videos later.
  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) bind(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
